var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasData)?_c('EstablishmentRolesComponent',{key:_vm.userTypeToken,attrs:{"userTypeToken":_vm.userTypeToken,"modelName":_vm.modelName}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }